import { Component, input } from '@angular/core';

@Component({
  selector: 'rt-impact-tracker-logo',
  templateUrl: './impact-tracker-logo.component.html',
  styleUrl: 'impact-tracker-logo.component.less',
})
export class ImpactTrackerLogoComponent {
  public logoHeading = input.required<string>();
}
